import { render, staticRenderFns } from "./uniformDetail.vue?vue&type=template&id=df34832e&scoped=true&"
import script from "./uniformDetail.vue?vue&type=script&lang=js&"
export * from "./uniformDetail.vue?vue&type=script&lang=js&"
import style0 from "./uniformDetail.vue?vue&type=style&index=0&id=df34832e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34832e",
  null
  
)

export default component.exports